import {
  createReducer,
  createRequestReducer
} from 'utils';

import { GET_STATIC_PAGE_CONTENT } from './constants';

const initialState = {
  items: []
};

export default createReducer(initialState, {
  [GET_STATIC_PAGE_CONTENT]: (state, action) => {
    const items = state.items.slice(0);
    let item = items.find(item => item.name === action.name);

    if (!item) {
      item = {
        name: action.name,
        data: null,
        isFetching: false,
        error: null
      };

      items.push(item);
    }

    const itemIndex = items.indexOf(item);

    return createRequestReducer(state, action, {
      SEND: (state) => {
        items.splice(itemIndex, 1, Object.assign({}, item, {
          isFetching: true,
          error: null
        }));

        return Object.assign(state, { items });
      },

      SUCCESS: (state, action) => {
        items.splice(itemIndex, 1, Object.assign({}, item, {
          data: action.request.response,
          isFetching: false
        }));

        return Object.assign(state, { items });
      },

      FAIL: (state, action) => {
        items.splice(itemIndex, 1, Object.assign({}, item, {
          isFetching: false,
          error: action.request.error
        }));

        return Object.assign(state, { items });
      }
    });
  }
});



// WEBPACK FOOTER //
// ./src/redux/StaticPages/reducer.js